import { render, staticRenderFns } from "./InstitucionalParceiros.vue?vue&type=template&id=072b286a&"
import script from "./InstitucionalParceiros.vue?vue&type=script&lang=js&"
export * from "./InstitucionalParceiros.vue?vue&type=script&lang=js&"
import style0 from "./InstitucionalParceiros.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports